import { SWRResponse } from 'swr'
import useSWRImmutable from 'swr/immutable'
import { CaoDeviceData } from '../common-types/products/cao'
import { fetcherExternal } from '../utils/fetcherExternal'

export function useCaoDeviceDatas(baseUrl: string, apiKey: string): SWRResponse<CaoDeviceData[]> {
  const url = `${baseUrl}/api/eclog/v1/sensors?apiKey=${apiKey}`
  return useSWRImmutable<CaoDeviceData[]>(url, fetcherExternal<CaoDeviceData[]>())
}
